import { useEffect, useState } from 'react';

const FALLBACK_MS = 8000;

interface UnoCSSReadyGateProps {
  children: React.ReactNode;
  isReady?: boolean;
}

export function UnoCSSReadyGate({ children, isReady = false }: UnoCSSReadyGateProps) {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (isReady) return;
    const id = window.setTimeout(() => setTimedOut(true), FALLBACK_MS);
    return () => window.clearTimeout(id);
  }, [isReady]);

  if (isReady || timedOut) {
    return <>{children}</>;
  }

  return <AppSkeleton />;
}

function AppSkeleton() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f3f4f6' }}>
      <style>{skeletonCSS}</style>

      <aside className="aga-gate-sidebar" style={{ width: 256, minWidth: 256, background: '#1e293b', padding: 16 }}>
        <div className="aga-gate-pulse" style={{ width: 120, height: 27, marginBottom: 32 }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {Array.from({ length: 6 }, (_, i) => (
            <div key={i} className="aga-gate-pulse" style={{ height: 40 }} />
          ))}
        </div>
      </aside>

      <div style={{ flex: 1 }}>
        <div
          style={{
            height: 83,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 24px',
            background: '#fff',
            borderBottom: '1px solid #e5e7eb',
          }}>
          <div className="aga-gate-pulse" style={{ width: 180, height: 24 }} />
          <div className="aga-gate-pulse" style={{ width: 100, height: 32, borderRadius: 6 }} />
        </div>

        <div style={{ padding: '28px 56px' }}>
          <div className="aga-gate-pulse" style={{ width: 280, height: 28, marginBottom: 24 }} />
          <div className="aga-gate-pulse" style={{ height: 160, marginBottom: 24 }} />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16 }}>
            <div className="aga-gate-pulse" style={{ height: 96, borderRadius: 8 }} />
            <div className="aga-gate-pulse" style={{ height: 96, borderRadius: 8 }} />
            <div className="aga-gate-pulse" style={{ height: 96, borderRadius: 8 }} />
          </div>
        </div>
      </div>
    </div>
  );
}

const skeletonCSS = `
@keyframes aga-skeleton-pulse{0%,100%{opacity:.45}50%{opacity:.9}}
.aga-gate-pulse{background:#d1d5db;border-radius:4px;animation:aga-skeleton-pulse 1.5s ease-in-out infinite}
.aga-gate-sidebar{display:none}
@media(min-width:1024px){.aga-gate-sidebar{display:block}}
`;
